var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIdeasV2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LogoIdeas_V2",
    "data-name": "LogoIdeas/V2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 49.942,
    viewBox: "0 0 143 49.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1540",
    "data-name": "Grupo 1540",
    transform: "translate(58.489 8.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_803",
    "data-name": "Trazado 803",
    d: "M210.893,120.205V101.84h4.377v18.365Z",
    transform: "translate(-210.893 -96.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_804",
    "data-name": "Trazado 804",
    d: "M256.847,100.207a13.845,13.845,0,0,1-.892,5.129,9.882,9.882,0,0,1-2.559,3.758,11.172,11.172,0,0,1-3.973,2.285,15.859,15.859,0,0,1-5.1.779q-1.482,0-3.317-.068t-3.013-.1V89.2q1.952-.068,3.721-.119t3.619-.051a17,17,0,0,1,4.815.626,9.2,9.2,0,0,1,3.619,1.98,8.663,8.663,0,0,1,2.29,3.487A14.624,14.624,0,0,1,256.847,100.207Zm-4.714.3a12.912,12.912,0,0,0-.387-3.335,6.247,6.247,0,0,0-1.229-2.438,5.321,5.321,0,0,0-2.206-1.523,9.151,9.151,0,0,0-3.283-.525q-.775,0-1.448.034t-1.213.068v15.4q.471.068,1.111.118t1.279.051a8.86,8.86,0,0,0,2.963-.474A6.164,6.164,0,0,0,251.595,104,10.247,10.247,0,0,0,252.133,100.512Z",
    transform: "translate(-228.262 -88.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_805",
    "data-name": "Trazado 805",
    d: "M300.538,112.262V89.409h13.7v3.656h-9.327v5.688H313.5v3.521h-8.586v6.2h9.427v3.792Z",
    transform: "translate(-268.35 -89.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_806",
    "data-name": "Trazado 806",
    d: "M359.956,112.262l-1.554-4.875h-8.527l-1.569,4.875h-4.444l7.6-22.853h5.69l7.655,22.853Zm-4.9-15.517q-.27-.877-.507-1.738t-.405-1.671h-.067q-.167.811-.4,1.688t-.468,1.687l-2.336,7.155h6.547Z",
    transform: "translate(-296.118 -89.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_807",
    "data-name": "Trazado 807",
    d: "M420.537,104.9a6.954,6.954,0,0,1-.572,2.827,6.211,6.211,0,0,1-1.684,2.252,7.906,7.906,0,0,1-2.727,1.473,11.876,11.876,0,0,1-3.67.525,21.139,21.139,0,0,1-5.286-.609v-4.2a15.622,15.622,0,0,0,2.652.728,15.042,15.042,0,0,0,2.822.288,6.623,6.623,0,0,0,1.554-.171,3.709,3.709,0,0,0,1.216-.514,2.277,2.277,0,0,0,.777-.891,2.918,2.918,0,0,0,.27-1.3,2.332,2.332,0,0,0-.659-1.693,6.473,6.473,0,0,0-1.96-1.269q-1.3-.592-2.517-1.117a11.778,11.778,0,0,1-2.247-1.269,6.019,6.019,0,0,1-1.706-1.93,5.875,5.875,0,0,1-.675-2.946,6.4,6.4,0,0,1,.572-2.725,5.769,5.769,0,0,1,1.684-2.116,8.17,8.17,0,0,1,2.727-1.371,12.386,12.386,0,0,1,3.6-.491,17.361,17.361,0,0,1,1.953.119q1.043.119,1.986.288v3.893a15.131,15.131,0,0,0-4.209-.643,4.773,4.773,0,0,0-2.811.694,2.265,2.265,0,0,0-.96,1.947,2.138,2.138,0,0,0,.657,1.591,6.675,6.675,0,0,0,1.936,1.219q1.279.576,2.542,1.134a12.941,12.941,0,0,1,2.323,1.32,5.921,5.921,0,0,1,1.734,1.981A6.085,6.085,0,0,1,420.537,104.9Z",
    transform: "translate(-336.026 -88.377)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1541",
    "data-name": "Grupo 1541",
    transform: "translate(57.022 40.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_808",
    "data-name": "Trazado 808",
    d: "M212.1,184.364l-3.4-5.381q-.53-.843-.752-1.227t-.431-.781H207.5q.012.36.031.942t.031,1.339q.012.757.025,1.463t.012,1.264v2.38h-.789v-8.369h.912l3.242,5.083q.469.744.764,1.252t.469.843h.013q-.025-.546-.043-1.221t-.031-1.3q-.012-.626-.019-1.271t-.006-1.227v-2.157h.789v8.369h-.8Z",
    transform: "translate(-206.807 -175.896)",
    fill: "#d0d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_809",
    "data-name": "Trazado 809",
    d: "M234.483,184.364v-8.369h4.475v.645h-3.686v3.087h3.378v.632h-3.378v3.347h3.748v.657Z",
    transform: "translate(-224.546 -175.896)",
    fill: "#d0d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_810",
    "data-name": "Trazado 810",
    d: "M257.043,176.652v7.711h-.789v-7.711h-2.577v-.657h5.943v.657Z",
    transform: "translate(-236.848 -175.896)",
    fill: "#d0d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_811",
    "data-name": "Trazado 811",
    d: "M284.155,184.364h-1l-1.8-6.162c-.058-.182-.109-.37-.154-.564s-.084-.378-.117-.552h-.025q-.062.335-.117.6t-.129.515l-1.751,6.162H278.04l-2.318-8.369h.851l1.665,6.038q.111.471.2.849t.16.75h.013c.057-.289.115-.56.173-.812s.119-.494.185-.725l1.739-6.1h.8l1.825,6.212q.1.334.191.707t.154.719h.012q.1-.471.148-.719t.124-.521l1.726-6.4h.777Z",
    transform: "translate(-250.978 -175.896)",
    fill: "#d0d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_812",
    "data-name": "Trazado 812",
    d: "M318.966,179.911a5.344,5.344,0,0,1-.3,1.859,4.023,4.023,0,0,1-.832,1.382A3.458,3.458,0,0,1,316.6,184a3.968,3.968,0,0,1-1.5.285,3.876,3.876,0,0,1-1.559-.3,3.124,3.124,0,0,1-1.153-.849,3.734,3.734,0,0,1-.709-1.327,5.783,5.783,0,0,1-.24-1.717,5.345,5.345,0,0,1,.3-1.86,4.023,4.023,0,0,1,.832-1.382,3.465,3.465,0,0,1,1.233-.849,3.965,3.965,0,0,1,1.5-.285,3.88,3.88,0,0,1,1.56.3,3.127,3.127,0,0,1,1.153.849,3.733,3.733,0,0,1,.709,1.327A5.783,5.783,0,0,1,318.966,179.911Zm-.826.161a4.335,4.335,0,0,0-.758-2.678,2.576,2.576,0,0,0-2.188-1,2.855,2.855,0,0,0-1.147.229,2.689,2.689,0,0,0-.937.682,3.13,3.13,0,0,0-.629,1.116,4.739,4.739,0,0,0-.222,1.506,5.712,5.712,0,0,0,.185,1.5,3.4,3.4,0,0,0,.554,1.172,2.5,2.5,0,0,0,.925.756,3.084,3.084,0,0,0,2.423.037,2.577,2.577,0,0,0,.937-.688,3.33,3.33,0,0,0,.629-1.122A4.613,4.613,0,0,0,318.14,180.072Z",
    transform: "translate(-273.866 -175.72)",
    fill: "#d0d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M345.132,184.3l-2.823-3.794h-.727V184.3h-.789v-8.356q.259-.012.826-.031t1.147-.019a4.562,4.562,0,0,1,1.128.13,2.653,2.653,0,0,1,.888.4,1.792,1.792,0,0,1,.579.682,2.187,2.187,0,0,1,.2.973,2.427,2.427,0,0,1-.185.973,2.054,2.054,0,0,1-.518.725,2.5,2.5,0,0,1-.764.465,3.517,3.517,0,0,1-.925.217q.1.1.3.341t.413.539l2.244,2.963Zm-.382-6.112a1.481,1.481,0,0,0-.536-1.24,2.461,2.461,0,0,0-1.548-.422q-.53,0-1.085.037v3.323q.136,0,.437.006t.6.006a2.432,2.432,0,0,0,1.584-.452A1.542,1.542,0,0,0,344.75,178.185Z",
    transform: "translate(-292.684 -175.83)",
    fill: "#d0d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_814",
    "data-name": "Trazado 814",
    d: "M368.184,184.364l-3.871-4.24v4.24h-.789v-8.369h.789v4.054l3.723-4.054h.986l-3.785,4.017,4.02,4.352Z",
    transform: "translate(-307.254 -175.896)",
    fill: "#d0d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_815",
    "data-name": "Trazado 815",
    d: "M386.736,184.364v-8.369h.789v8.369Z",
    transform: "translate(-322.131 -175.896)",
    fill: "#d0d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_816",
    "data-name": "Trazado 816",
    d: "M404.936,184.364l-3.4-5.381q-.53-.843-.752-1.227t-.431-.781h-.012q.012.36.031.942t.031,1.339q.012.757.025,1.463t.012,1.264v2.38h-.789v-8.369h.912l3.242,5.083q.469.744.764,1.252t.469.843h.013q-.025-.546-.043-1.221t-.031-1.3q-.012-.626-.019-1.271t-.006-1.227v-2.157h.789v8.369h-.8Z",
    transform: "translate(-330.406 -175.896)",
    fill: "#d0d7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_817",
    "data-name": "Trazado 817",
    d: "M431.757,183.829a7.252,7.252,0,0,1-1.307.341,8.3,8.3,0,0,1-1.369.118,4.92,4.92,0,0,1-1.708-.279,3.49,3.49,0,0,1-1.289-.812,3.553,3.553,0,0,1-.813-1.308,5.03,5.03,0,0,1-.284-1.742,5.433,5.433,0,0,1,.277-1.767,3.935,3.935,0,0,1,.832-1.414,3.656,3.656,0,0,1,1.381-.924,5.124,5.124,0,0,1,1.874-.322,7.334,7.334,0,0,1,1.067.081,8.653,8.653,0,0,1,1.079.229v.793a6.5,6.5,0,0,0-1.116-.328,5.759,5.759,0,0,0-1.14-.118,3.766,3.766,0,0,0-1.516.285,2.826,2.826,0,0,0-1.073.794,3.377,3.377,0,0,0-.623,1.165,4.71,4.71,0,0,0-.2,1.4,4.6,4.6,0,0,0,.234,1.525,3.1,3.1,0,0,0,.678,1.134,2.836,2.836,0,0,0,1.066.7,3.933,3.933,0,0,0,1.4.236,5.725,5.725,0,0,0,.906-.068,5.983,5.983,0,0,0,.857-.2V180.01h.789Z",
    transform: "translate(-346.649 -175.72)",
    fill: "#d0d7e0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1553",
    "data-name": "Grupo 1553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1552",
    "data-name": "Grupo 1552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_818",
    "data-name": "Trazado 818",
    d: "M106.167,80.645A16.314,16.314,0,0,0,84.606,65.21,16.447,16.447,0,0,0,73.861,80.568a14.325,14.325,0,0,0,.148,2.734,20.152,20.152,0,0,0,5.929,10.621c2.5,2.4,5.419,5.747,5.419,8.183l4.248.291,5.058-.291c0-2.435,2.918-5.758,5.419-8.159a19.83,19.83,0,0,0,5.787-10.588,15,15,0,0,0,.3-2.714Z",
    transform: "translate(-64.574 -64.343)",
    fill: "#ffd100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_819",
    "data-name": "Trazado 819",
    d: "M110.132,90.221l-1.865-.39a.194.194,0,0,1-.152-.169,8.171,8.171,0,0,0-.236-1.243.193.193,0,0,1,.08-.214l1.6-1.044a.517.517,0,0,0,.149-.715l-2.074-3.17a.517.517,0,0,0-.715-.149l-1.6,1.044a.193.193,0,0,1-.228-.012,8.129,8.129,0,0,0-1.045-.714.194.194,0,0,1-.094-.207l.39-1.865a.517.517,0,0,0-.4-.611l-3.708-.774a.516.516,0,0,0-.611.4l-.39,1.865a.193.193,0,0,1-.169.152,8.167,8.167,0,0,0-1.244.236.193.193,0,0,1-.214-.08l-1.044-1.6a.517.517,0,0,0-.715-.149l-3.17,2.074a.517.517,0,0,0-.149.715l1.044,1.6a.193.193,0,0,1-.012.227,8.123,8.123,0,0,0-.714,1.045.193.193,0,0,1-.207.094l-1.866-.389a.516.516,0,0,0-.611.4l-.775,3.708a.516.516,0,0,0,.4.611l1.865.39a.193.193,0,0,1,.152.169,8.187,8.187,0,0,0,.236,1.244.192.192,0,0,1-.08.213l-1.6,1.044a.517.517,0,0,0-.149.715l2.074,3.17a.517.517,0,0,0,.715.149l1.607-1.052a.175.175,0,0,1,.206.011,8.2,8.2,0,0,0,1.067.729.175.175,0,0,1,.085.187l-.392,1.879a.516.516,0,0,0,.4.611l3.708.775a.516.516,0,0,0,.611-.4l.392-1.879a.175.175,0,0,1,.153-.137,8.119,8.119,0,0,0,1.27-.241.175.175,0,0,1,.193.072l1.051,1.607a.517.517,0,0,0,.715.149l3.17-2.074a.517.517,0,0,0,.149-.715l-1.044-1.6a.193.193,0,0,1,.012-.228,8.129,8.129,0,0,0,.714-1.045.194.194,0,0,1,.208-.094l1.865.389a.517.517,0,0,0,.611-.4l.774-3.708A.516.516,0,0,0,110.132,90.221Zm-11.1,4.795a4.553,4.553,0,1,1,5.387-3.526A4.553,4.553,0,0,1,99.029,95.016Z",
    transform: "translate(-74.522 -74.364)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_820",
    "data-name": "Trazado 820",
    d: "M114.948,197.523h-4.867a.739.739,0,0,1-.716-.556l-.472-1.849a.739.739,0,0,1,.716-.922H115.3a.739.739,0,0,1,.726.878l-.354,1.849A.739.739,0,0,1,114.948,197.523Z",
    transform: "translate(-87.017 -147.581)",
    fill: "#001b26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1548",
    "data-name": "Grupo 1548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1542",
    "data-name": "Grupo 1542",
    transform: "translate(5.065 23.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_821",
    "data-name": "Trazado 821",
    d: "M62.1,132.312a1.886,1.886,0,0,0,1.971,1.942,2,2,0,0,0,1.95-1.266,2.065,2.065,0,0,0-2.644-2.644,2.027,2.027,0,0,0-1.277,1.967Z",
    transform: "translate(-62.105 -130.222)",
    fill: "#ffd100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1543",
    "data-name": "Grupo 1543",
    transform: "translate(39.742 27.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_822",
    "data-name": "Trazado 822",
    d: "M158.7,142.082a1.886,1.886,0,0,0,1.971,1.942,2,2,0,0,0,1.95-1.266,2.065,2.065,0,0,0-2.644-2.643,2.027,2.027,0,0,0-1.277,1.967Z",
    transform: "translate(-158.704 -139.992)",
    fill: "#ffd100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1544",
    "data-name": "Grupo 1544",
    transform: "translate(7.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_823",
    "data-name": "Trazado 823",
    d: "M68.7,66.433a1.886,1.886,0,0,0,1.971,1.942,2,2,0,0,0,1.95-1.266,2.065,2.065,0,0,0-2.644-2.643A2.027,2.027,0,0,0,68.7,66.433Z",
    transform: "translate(-68.703 -64.343)",
    fill: "#ffd100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1545",
    "data-name": "Grupo 1545",
    transform: "translate(41.9 4.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_824",
    "data-name": "Trazado 824",
    d: "M164.713,79.279a1.886,1.886,0,0,0,1.97,1.942,2,2,0,0,0,1.95-1.266,2.065,2.065,0,0,0-2.644-2.644,2.027,2.027,0,0,0-1.277,1.967Z",
    transform: "translate(-164.713 -77.189)",
    fill: "#ffd100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1546",
    "data-name": "Grupo 1546",
    transform: "translate(45.656 14.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_825",
    "data-name": "Trazado 825",
    d: "M180.623,107.468a2.8,2.8,0,0,1-.269,1.2,2.656,2.656,0,0,1-2.525,1.456,2.551,2.551,0,0,1-2.652-2.657,2.664,2.664,0,0,1,1.432-2.543,2.813,2.813,0,0,1,4.013,2.543Z",
    transform: "translate(-175.178 -104.656)",
    fill: "#ffd100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1547",
    "data-name": "Grupo 1547",
    transform: "translate(0 10.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_826",
    "data-name": "Trazado 826",
    d: "M53.441,97.035a2.8,2.8,0,0,1-.269,1.2,2.656,2.656,0,0,1-2.525,1.456A2.551,2.551,0,0,1,48,97.035a2.664,2.664,0,0,1,1.433-2.543,2.813,2.813,0,0,1,4.013,2.543Z",
    transform: "translate(-47.996 -94.223)",
    fill: "#ffd100"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_920",
    "data-name": "Trazado 920",
    d: "M2.872,0H9.76a2.872,2.872,0,0,1,2.872,2.872V7.141a3.59,3.59,0,0,1-3.59,3.59H3.59A3.59,3.59,0,0,1,0,7.141V2.872A2.872,2.872,0,0,1,2.872,0Z",
    transform: "translate(19.123 37.336)",
    fill: "#c6dfe7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1549",
    "data-name": "Grupo 1549",
    transform: "translate(20.307 39.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_827",
    "data-name": "Trazado 827",
    d: "M114.4,174.641h-9.414a.425.425,0,0,1,0-.849H114.4a.425.425,0,1,1,0,.849Z",
    transform: "translate(-104.563 -173.792)",
    fill: "#001b26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1550",
    "data-name": "Grupo 1550",
    transform: "translate(20.307 42.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_828",
    "data-name": "Trazado 828",
    d: "M114.4,182.528h-9.414a.425.425,0,1,1,0-.849H114.4a.425.425,0,1,1,0,.849Z",
    transform: "translate(-104.563 -181.679)",
    fill: "#001b26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1551",
    "data-name": "Grupo 1551",
    transform: "translate(20.307 44.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_829",
    "data-name": "Trazado 829",
    d: "M114.4,190.415h-9.414a.425.425,0,0,1,0-.849H114.4a.425.425,0,1,1,0,.849Z",
    transform: "translate(-104.563 -189.566)",
    fill: "#001b26"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1554",
    "data-name": "Grupo 1554",
    transform: "translate(58.116 6.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_830",
    "data-name": "Trazado 830",
    d: "M209.852,83.769a2.48,2.48,0,0,0,2.585,2.562,2.617,2.617,0,0,0,2.558-1.67,2.726,2.726,0,0,0-2.546-3.648,2.58,2.58,0,0,0-2.6,2.756Z",
    transform: "translate(-209.852 -81.013)",
    fill: "#ffd100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIdeasV2);
export default __webpack_public_path__ + "static/media/logo_ideas_v2.217a1b214ad5dac8e71d1e6f9e42a28c.svg";
export { ForwardRef as ReactComponent };